module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vskel1-13fb84ee503c3891ee097e8ae259267a.jpg";